import styles from './country.module.scss'
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { compare, formatCash } from 'utils'

//antd
import { Input, Row, Col, Table, Button, notification, Popconfirm } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined, EditOutlined } from '@ant-design/icons'

//components
import CountryForm from './country-form'

//apis
import { getCountries, deleteCountry, getFullCountries } from 'apis/country'
import { IMAGE_DEFAULT } from 'consts'

export default function Country() {
  const typingTimeoutRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [allCountry, setAllCountry] = useState([])
  const [countCountry, setCountCountry] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20, is_show_password: true })

  const [valueSearch, setValueSearch] = useState('')
  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _deleteCountry = async (id) => {
    try {
      setLoading(true)
      const res = await deleteCountry([id])
      if (res.status === 200) {
        if (res.data.success) {
          _getCountries()
          notification.success({ message: 'Xóa quốc gia thành công' })
        } else
          notification.error({
            message: res.data.message || 'Xóa quốc gia thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa quốc gia thất bại, vui lòng thử lại',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _getCountries = async () => {
    try {
      setLoading(true)
      const res = await getCountries({ ...paramsFilter })
      console.log(res)
      if (res.status === 200) {
        setCountries(res.data.data)
        setCountCountry(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _getAllCountry = async () => {
    try {
      const res = await getFullCountries()
      if (res.status === 200) setAllCountry(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Hình ảnh quốc gia',
      render: (text, record) => (
        <img
          src={record.image_url || IMAGE_DEFAULT}
          style={{ width: 80, height: 80, objectFit: 'contain' }}
          alt=""
        />
      ),
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Hình ảnh giới thiệu',
      render: (text, record) =>
        record.image_intro &&
        record.image_intro.map((img) => (
          <img
            src={img || IMAGE_DEFAULT}
            style={{ width: 60, height: 60, marginRight: 5, objectFit: 'contain' }}
            alt=""
          />
        )),
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Tên quốc gia',
      dataIndex: 'name',
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      title: 'Subdomain',
      dataIndex: 'subdomain',
      sorter: (a, b) => compare(a, b, 'subdomain'),
    },
    {
      title: 'Tiền tệ',
      dataIndex: 'currency',
      sorter: (a, b) => compare(a, b, 'currency'),
    },
    {
      title: 'Tỉ lệ đổi giá (so với USD)',
      render: (text, record) => formatCash(record.rate_currency || 0),
      sorter: (a, b) => compare(a, b, 'rate_currency'),
    },
    {
      title: 'Đơn hàng tối thiểu',
      render: (text, record) => formatCash(record.require_amount_order || 0),
      sorter: (a, b) => compare(a, b, 'require_amount_order'),
    },
    {
      title: 'Deposit for one guest',
      render: (text, record) => formatCash(record.require_amount_deposit || 0),
      sorter: (a, b) => compare(a, b, 'require_amount_deposit'),
    },
    {
      title: 'Deposit for one Baby',
      render: (text, record) => formatCash(record.require_amount_baby || 0),
      sorter: (a, b) => compare(a, b, 'require_amount_baby'),
    },
    {
      title: 'Paypal ID',
      dataIndex: 'paypal',
      sorter: (a, b) => compare(a, b, 'paypal'),
    },
    {
      title: 'Timezone',
      render: (text, record) => record.timezone,
    },
    {
      width: 100,
      title: 'Ưu tiên hiển thị',
      render: (text, record) => <div>{record.priority ? record.priority : 'Chưa cài đặt'}</div>,
    },
    // {
    //   title: 'Độ ưu tiên',
    //   dataIndex: 'priority',
    // },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render: (text, record) => (text ? moment(text).format('DD-MM-YYYY HH:mm') : ''),
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    },
    {
      title: '',
      width: 100,
      render: (text, record) => (
        <Row justify="space-between">
          <Popconfirm
            onConfirm={() => _deleteCountry(record.country_id)}
            title="Bạn có muốn xóa quốc gia này không?"
          >
            <Button icon={<DeleteOutlined />} type="primary" danger />
          </Popconfirm>
          <CountryForm countries={allCountry} infoCountry={record} reloadData={_getCountries}>
            <Button icon={<EditOutlined />} type="primary" />
          </CountryForm>
        </Row>
      ),
    },
  ]

  useEffect(() => {
    _getAllCountry()
  }, [])

  useEffect(() => _getCountries(), [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý quốc gia</div>
        <CountryForm countries={allCountry} reloadData={_getCountries}>
          <Button size="large" icon={<PlusCircleOutlined />} type="primary">
            Thêm quốc gia
          </Button>
        </CountryForm>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Input
            size="large"
            style={{ width: '100%' }}
            name="name"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo tên quốc gia"
            allowClear
          />
        </Col>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={countries}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countCountry,
        }}
      />
    </div>
  )
}
